/* eslint-disable no-underscore-dangle */
import 'classlist-polyfill';
import 'whatwg-fetch';
import Cookies from 'js-cookie';

class LockProxy {
  constructor(lock, state, isLocal) {
    this._lock = lock;
    this._state = state;
    this._isLocal = isLocal;
  }

  get lock() {
    return this._lock;
  }

  on(event, callback) {
    this._lock.on(event, callback);
  }

  show(options = {}) {
    const cookieOptions = {
      domain: this._isLocal ? 'localhost' : 'logrocket.com',
      // 30 minutes in days
      expires: 1 / 48,
    };

    // Retrieved on app.logrocket.com and passed to auth0.js when parsing hash.
    // This cookie should be set immediately prior to showing the Lock modal to
    // people signing up or logging in.
    Cookies.set('com.logrocket.login.state', this._state, cookieOptions);

    this._lock.show(options);
  }
}

/**
 * Creates an Auth0 Lock widget
 *
 * @param {boolean} isLocal - decides auth0 environment
 * @param {object} options - Lock options to merge with the defaults
 */
export default function makeAuth0Lock(isLocal = false, options = {}) {
  if (!window.Auth0Lock) {
    throw new Error('Auth0 Lock not found');
  }
  const redirectUrl = isLocal ? 'http://localhost:3000' : 'https://app.logrocket.com';

  // const params = parse(window.location.search);
  // if (params.ref === 'producthunt') {
  //   redirectUrl += '?coupon=producthunt';
  // }

  // Random string, from: https://gist.github.com/6174/6062387
  const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(
    36,
  ).substring(2, 15);

  const config = {
    theme: {
      logo: 'https://assets.logrocket.com/public/6da2763713826956286a.png',
      primaryColor: '#926fca',
    },
    socialButtonStyle: 'big',
    auth: {
      redirect: true,
      redirectUrl,
      responseType: 'token id_token',
      autoParseHash: false,
      params: {
        scope: 'openid profile email',
        state,
      },
    },
    languageDictionary: {
      title: 'LogRocket',
    },
    // required when using a custom domain
    // https://auth0.com/docs/libraries/lock/v11/migration-v10-v11#configure-your-custom-domain
    configurationBaseUrl: 'https://cdn.auth0.com',
    ...options,
  };

  // eslint-disable-next-line no-undef
  const lock = new Auth0Lock(
    isLocal ? 'lHtXjJPLT7m7TeEYm0aeVBS8DAdJhDcu' : 'FoUYTXQQwQPt9jHvlQgMiLzQg60NKFNW',
    isLocal ? 'logrocket-dev.auth0.com' : 'login.logrocket.com',
    config,
  );

  return new LockProxy(lock, state, isLocal);
}
